import { IComponentOptions } from "angular";
import { ConversionModalComponentController } from "./controller";

export const vsName = "conversionModal";
export const conversionModalComponentOptions: IComponentOptions = {
  controller: ConversionModalComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    modalInstance: "=",
    resolve: "=",
  },
};
